import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import Header2 from "../Coman/Header2";
import Footer2 from "../Coman/Footer2";

export default function PrivacyPolicy() {
    return (
        <div className="privacy-page" style={{ background: "#ffffff", minHeight: "100vh" }}>
            <div className="container" style={{ paddingTop: "40px", paddingBottom: "20px" }}>
                <Link to="/" style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "10px",
                    color: "var(--theme-color)",
                    textDecoration: "none",
                    fontSize: "15px",
                    fontWeight: "700",
                    padding: "10px 24px",
                    borderRadius: "50px",
                    border: "2px solid var(--theme-color)",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    transition: "all 0.3s ease"
                }}>
                    <Home size={18} />
                    Go Back Home
                </Link>
            </div>

            <section className="section-b-space" style={{ paddingBottom: "100px" }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="privacy-container" style={{
                                background: "#ffffff",
                                backdropFilter: "blur(10px)",
                                borderRadius: "30px",
                                border: "1px solid rgba(0, 0, 0, 0.08)",
                                padding: "calc(25px + (60 - 25) * ((100vw - 320px) / (1920 - 320)))",
                                boxShadow: "0 20px 50px rgba(0,0,0,0.08)"
                            }}>
                                <div className="mb-5 pb-4" style={{ borderBottom: "1px solid rgba(0,0,0,0.1)" }}>
                                    <h2 className="mb-3" style={{ color: "#1a1a1a", fontWeight: "700" }}>Privacy Policy

                                    </h2>
                                    <p style={{ color: "rgba(0,0,0,0.5)", fontSize: "16px", textAlign: "left" }}>AGN respects your privacy and is committed to protecting your personal data.

                                    </p>
                                </div>

                                <div className="privacy-content">
                                    <div className="privacy-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>01</span>
                                            Information We Collect


                                        </h4>
                                        <div style={{ paddingLeft: "50px" }}>
                                            <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", textAlign: "left" }}>We may collect:
                                            </p>
                                            <ul style={{ listStyleType: "none", padding: "0", marginTop: "10px" }}>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span> Name, email, phone number

                                                </li>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span> Payment-related details

                                                </li>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span>Account activity data

                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="privacy-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>02</span>
                                            How We Use Information

                                        </h4>
                                        <div style={{ paddingLeft: "50px" }}>
                                            <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", textAlign: "left" }}>Your data is used to:
                                            </p>
                                            <ul style={{ listStyleType: "none", padding: "0", marginTop: "10px" }}>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span> Provide and manage services

                                                </li>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span> Process transactions

                                                </li>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span> Improve user experience
                                                </li>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span> Communicate updates

                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="privacy-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>03</span>
                                            Data Protection

                                        </h4>
                                        <div style={{ paddingLeft: "50px" }}>
                                            <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", textAlign: "left" }}>
                                                We implement reasonable security measures to protect your data. However, no system is completely secure.


                                            </p>
                                        </div>
                                    </div>

                                    <div className="privacy-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>04</span>
                                            Sharing of Information

                                        </h4>
                                        <div style={{ paddingLeft: "50px" }}>
                                            <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", textAlign: "left" }}>We do not sell your personal data.
                                            </p>
                                            <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", textAlign: "left" }}> We may share data with:
                                            </p>
                                            <ul style={{ listStyleType: "none", padding: "0", marginTop: "10px" }}>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span> Service providers

                                                </li>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span> Legal authorities (if required)

                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="privacy-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>05</span>
                                            Cookies & Tracking

                                        </h4>
                                        <div style={{ paddingLeft: "50px" }}>
                                            <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", textAlign: "left" }}>AGN may use cookies to:
                                            </p>
                                            <ul style={{ listStyleType: "none", padding: "0", marginTop: "10px" }}>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span>Enhance user experience

                                                </li>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span>Analyze website performance

                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="privacy-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>06</span>
                                            User Rights

                                        </h4>
                                        <div style={{ paddingLeft: "50px" }}>
                                            <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", textAlign: "left" }}>You may:
                                            </p>
                                            <ul style={{ listStyleType: "none", padding: "0", marginTop: "10px" }}>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span> Request access to your data

                                                </li>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span> Request correction or deletion

                                                </li>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span> Opt-out of communications

                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="privacy-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>07</span>
                                            Third-Party Links


                                        </h4>
                                        <div style={{ paddingLeft: "50px" }}>
                                            <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", textAlign: "left" }}>
                                                AGN is not responsible for the privacy practices of external websites.


                                            </p>
                                        </div>
                                    </div>

                                    <div className="privacy-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>08</span>
                                            Data Retention


                                        </h4>
                                        <div style={{ paddingLeft: "50px" }}>
                                            <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", textAlign: "left" }}>
                                                We retain user data only as long as necessary for operational and legal purposes.



                                            </p>
                                        </div>
                                    </div>

                                    <div className="privacy-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>09</span>
                                            Policy Updates


                                        </h4>
                                        <div style={{ paddingLeft: "50px" }}>
                                            <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", textAlign: "left" }}>
                                                This Privacy Policy may be updated periodically.

                                            </p>
                                        </div>
                                    </div>

                                    <div className="privacy-block">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>10</span>
                                            Contact

                                        </h4>
                                        <div style={{ paddingLeft: "50px" }}>
                                            <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", textAlign: "left" }}>
                                                For privacy concerns, contact:

                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <Footer2 /> */}
        </div>
    );
}
